/**
 * Libraries
 */
import React, { ButtonHTMLAttributes, ReactNode } from 'react'

/**
 * Components
 */
import { Button } from 'app/components/common'
import { ReloadIcon } from 'app/components/icons/'

type GoBackButtonProps = {
  children?: ReactNode
  className?: string
  onClick?: () => void
  text?: string
} & ButtonHTMLAttributes<HTMLButtonElement>

const GoBackButton = ({
  children = <ReloadIcon width={46} height={38} />,
  className = '',
  onClick,
  text = 'Go back',
  ...other
}: GoBackButtonProps) => {
  function defaultOnClick() {
    window.history.back()
  }

  return (
    <Button
      onClick={onClick || defaultOnClick}
      className={className}
      {...other}
    >
      {children}
      {text}
    </Button>
  )
}

export default GoBackButton
